import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../../reducers/reducer";
import MultiStepView from "../../../views/DashboardView/CardView/AllocationView/MultiStepView";
import {
  allocateUpdateCustomerReq,
  changeStep,
} from "../../../reducers/card/allocation/multiStep/index";

interface Props {
  periodName: string;
  isSimulation: boolean;
  isJoint: boolean;
  activeStep: number;
  isFetching: boolean;
  steps: any;
  allocateUpdateCustomerReq: any;
  changeStep: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      periodName: state.card.main.activePeriod
        ? state.card.main.activePeriod.name
        : "-",
      isSimulation: state.card.main.isSimulation,
      isJoint: state.card.main.isJoint,
      activeStep: state.card.allocation.multiStep.activeStep,
      isFetching: state.card.allocation.multiStep.isFetching,
      steps: state.card.allocation.multiStep.steps,
    }),
    (dispatch: any) => ({
      dispatch,
      changeStep: (step: number) => dispatch(changeStep(step)),
      allocateUpdateCustomerReq: (
        id: number,
        index: number,
        value: number,
        requirement: { id: number; index: number; type: string },
        customer: { id: number; index: number }
      ) =>
        dispatch(
          allocateUpdateCustomerReq(id, index, value, requirement, customer)
        ),
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(MultiStepView);
